import React, { type FunctionComponent } from 'react'
import { PageHeader } from '@retailer-platform/shared-components'
import { ProductsBreadcrumbs } from 'domains/products/components/breadcrumbs/ProductsBreadcrumbs'

interface ProductsSearchHeaderProps {}

export const ProductsSearchHeader: FunctionComponent<ProductsSearchHeaderProps> = () => (
  <PageHeader addBottomPadding title={<ProductsBreadcrumbs />} />
)
